import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import PhoneInput from './../../FormComponents/PhoneInput';
import TextareaCounter from './../../FormComponents/TextareaCounter';

export default function Mandatory(props) {
  const {
    errors,
    onChange,
    onBlur,
    setRef,
    softwares,
    disabled,
    preferences,
  } = props;
  const { isSchemaFetched, schema } = preferences;
  const details = Object.assign(
    {
      business_contact_numbers: [' '],
      business_working_hours: {},
      business_open_days: {},
    },
    props.details,
  );

  const renderAddressDetails = (info, index) => {
    const onAddressDetailsChange = (event) => {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      const name = target.name;

      if (value === '' || value?.trim().length > 0) {
        const newValue = details.address_details.slice();
        newValue[index] = Object.assign({}, info, {
          [name]: value,
        });

        onChange({
          target: {
            name: 'address_details',
            value: newValue,
            fieldName: `${index}.${name}`,
          },
        });
      }
    };

    return [
      <div className="mandatory__row" key={`address-${index}`}>
        <p className="mandatory__row__label">
          Business location Address<sup>*</sup>
        </p>
        <div className="business__row__input">
          <textarea
            rows="3"
            name="address"
            placeholder="Provide full address"
            value={info.address}
            onChange={onAddressDetailsChange}
            className={classnames({
              'has-error': errors[`address_details.${index}.address`],
            })}
            ref={(c) => {
              setRef(c, `address_details.${index}.address`);
            }}
          />
          <span className="message--small message--error">
            {errors[`address_details.${index}.address`] &&
              errors[`address_details.${index}.address`].message}
          </span>
        </div>
      </div>,
      <div className="mandatory__row" key={`location-tip-${index}`}>
        <p className="mandatory__row__label">Location Tip</p>
        <div className="business__row__input">
          <TextareaCounter
            rows="3"
            placeholder="Enter location tip"
            name="location_tip"
            value={info.location_tip}
            onChange={onAddressDetailsChange}
            className={classnames({ 'has-error': errors.first_message })}
            setRef={setRef}
            maxLength={160}
          />
        </div>
      </div>,
      <div className="mandatory__row" key={`parking-tip-${index}`}>
        <p className="mandatory__row__label">Parking Tip</p>
        <div className="business__row__input">
          <TextareaCounter
            rows="3"
            name="parking_tip"
            placeholder="Enter parking tip"
            value={info.parking_tip}
            onChange={onAddressDetailsChange}
            className={classnames({ 'has-error': errors.first_message })}
            setRef={setRef}
            maxLength={160}
          />
        </div>
      </div>,
      <div className="business__row" key={`Url-tip-${index}`}>
        <p className="business__row__label">Link to your website</p>
        <div className="business__row__input">
          <input
            type="text"
            name="website_link"
            value={details.website_link}
            onChange={onChange}
            className={classnames({ 'has-error': errors.website_link })}
            disabled={disabled}
            ref={setRef}
          />
          <span className="message--small message--error">
            {errors.website_link && errors.website_link.message}
          </span>
        </div>
      </div>,
      <div className="business__row" key={`Faq-tip-${index}`}>
        <p className="business__row__label">Link to your FAQs</p>
        <div className="business__row__input">
          <input
            type="text"
            name="faqs_link"
            value={details.faqs_link}
            onChange={onChange}
            className={classnames({ 'has-error': errors.faqs_link })}
            disabled={disabled}
            ref={setRef}
          />
          <span className="message--small message--error">
            {errors.faqs_link && errors.faqs_link.message}
          </span>
        </div>
      </div>,
    ];
  };

  if (
    details.business_contact_numbers &&
    !details.business_contact_numbers.length
  ) {
    details.business_contact_numbers.push(' ');
  }

  const renderBusinessPhone = (contactNumber, index) => {
    // if (!contactNumber && index !== 0) return null;

    const onPhoneNumberChange = (event) => {
      details.business_contact_numbers[index] = event.target.value;
      onChange({
        target: {
          name: 'business_contact_numbers',
          value: details.business_contact_numbers,
        },
      });
    };

    const onPhoneNumberBlur = (event) => {
      if (index === 0) {
        onBlur({
          target: {
            name: 'business_contact_numbers.0',
            value: event.target.value,
          },
        });
      }
    };

    return (
      <div
        className="business-phone"
        key={index}
        ref={(c) => {
          setRef(c, `business_contact_numbers.${index}`);
        }}
      >
        <PhoneInput
          placeholder="Enter phone number"
          name={`business_contact_numbers[${index}]`}
          value={contactNumber}
          onChange={onPhoneNumberChange}
          onBlur={onPhoneNumberBlur}
          className={classnames({
            'has-error': errors[`business_contact_numbers.${index}`],
          })}
        />
        <span className="message--small message--error">
          {errors[`business_contact_numbers.${index}`] &&
            errors[`business_contact_numbers.${index}`].message}
        </span>
      </div>
    );
  };

  const onAddBusinessContact = (event) => {
    event.preventDefault();

    onChange({
      target: {
        name: 'business_contact_numbers',
        value: details.business_contact_numbers.concat([' ']),
      },
    });
  };

  const onBillingContactDetailsChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    onChange({
      target: {
        name: 'billing_contact_details',
        value: Object.assign({}, details.billing_contact_details, {
          [name]: value,
        }),
        fieldName: name,
      },
    });
  };

  return (
    <div className="mandatory">
      {schema?.address_details && (
        <>{(details.address_details || []).map(renderAddressDetails)}</>
      )}
      {schema?.business_contact_numbers && (
        <div className="mandatory__row">
          <p className="mandatory__row__label">
            {schema?.business_contact_numbers?.description ||
              'Best phone number(s) to reach business'}
            <sup>*</sup>
          </p>
          <div className="mandatory__row__input">
            {(details.business_contact_numbers || []).map(renderBusinessPhone)}
            <a href="" onClick={onAddBusinessContact} className="btn btn--link">
              Add another number
            </a>
          </div>
        </div>
      )}
      {schema?.billing_contact_details && (
        <div className="mandatory__row">
          <p className="mandatory__row__label">
            {schema?.billing_contact_details?.description ||
              'Whom can TrueLark contact for system/billing related information?'}
            <sup>*</sup>
          </p>
          <div className="mandatory__row__input business-phone">
            <input
              type="text"
              name="name"
              placeholder="Enter name"
              value={(details.billing_contact_details || {}).name}
              onChange={onBillingContactDetailsChange}
              className={classnames({
                'has-error': errors['billing_contact_details.name'],
              })}
              ref={(c) => {
                setRef(c, 'billing_contact_details.name');
              }}
            />
            <span className="message--small message--error">
              {errors['billing_contact_details.name'] &&
                errors['billing_contact_details.name'].message}
            </span>
            <input
              type="email"
              name="email"
              placeholder="Enter email"
              value={(details.billing_contact_details || {}).email}
              onChange={onBillingContactDetailsChange}
              className={classnames({
                'has-error': errors['billing_contact_details.email'],
              })}
              ref={(c) => {
                setRef(c, 'billing_contact_details.email');
              }}
            />
            <span className="message--small message--error">
              {errors['billing_contact_details.email'] &&
                errors['billing_contact_details.email'].message}
            </span>
            <div
              className="business-phone"
              ref={(c) => {
                setRef(c, 'billing_contact_details.phone_number');
              }}
            >
              <PhoneInput
                placeholder="Enter phone number"
                name="phone_number"
                value={(details.billing_contact_details || {}).phone_number}
                onChange={onBillingContactDetailsChange}
                className={classnames({
                  'has-error': errors['billing_contact_details.phone_number'],
                })}
              />
              <span className="message--small message--error">
                {errors['billing_contact_details.phone_number'] &&
                  errors['billing_contact_details.phone_number'].message}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

Mandatory.defaultProps = {
  onChange: () => {},
  onBlur: () => {},
  setRef: () => {},
  details: {},
  errors: {},
  softwares: {},
  disabled: false,
};

Mandatory.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  setRef: PropTypes.func,
  details: PropTypes.shape(),
  errors: PropTypes.shape(),
  softwares: PropTypes.shape(),
  disabled: PropTypes.bool,
};
